import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent, CfetPageNamesConstant, CfetService, CFETILMEndpointsConstant, UrlUtil } from '../../cfet-core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-utf-auth-landing-page',
    templateUrl: './utf-auth-landing-page.component.html',
    styleUrls: ['./utf-auth-landing-page.component.scss'],
    standalone: false
})
export class UtfAuthLandingPageComponent extends CfetBaseComponent implements OnInit {
  affiliationCodeForm: UntypedFormGroup;
  affiliationCode: UntypedFormControl;
  showLandingPage = true;
  showAffiliationCodePage = false;
  disabledSubmitButton = true;
  isSpaOrg: boolean;
  isAffiliationEnable: boolean = false;
  isValidAffCode: boolean = true;
  copyAffiliationCode: any;
  isInvalidCode: boolean;
  OrgDetails: any = {};
  showLoading = false;
  showLandingContainer = true;
  httpHeaders: any = {};
  amContactEmail: any;
  amEmailVerified: any;
  amFirstName: any;
  amLastName: any;
  amUserId: any;
  validEmail: boolean;
  returnUrl: any;
  constructor(private cfetService: CfetService,
    private activatedRoute: ActivatedRoute,
    private urlUtil: UrlUtil) {
    super();
  }

  ngOnInit() {
    this.affiliationCode = new UntypedFormControl('', [Validators.required]);
    this.affiliationCodeForm = new UntypedFormGroup({
      affiliationCode: this.affiliationCode
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.settingReturnUrl(params);
      if (this.returnUrl && this.returnUrl.length !== 0) {
        sessionStorage.setItem('returnUrl', JSON.stringify(this.returnUrl));
      } else if (sessionStorage.getItem('returnUrl') && sessionStorage.getItem('returnUrl').length !== 0) {
        this.returnUrl = JSON.parse(sessionStorage.getItem('returnUrl'));
      }
    });
  }

  settingReturnUrl(params) {
    if (params && params['returnURL']) {
      this.returnUrl = this.sanitizeReturnUrl(params['returnURL']);
      if (!this.returnUrl) {
        return;
      }
      if (params['host']) {
        this.returnUrl = this.returnUrl + '&host=' + params['host'];
      }
      if (params['state']) {
        this.returnUrl = this.returnUrl + '&state=' + params['state'];
      }
      if (params['client_id']) {
        this.returnUrl = this.returnUrl + '&client_id=' + params['client_id'];
      }
      if (params['is_passive']) {
        this.returnUrl = this.returnUrl + '&is_passive=' + params['is_passive'];
      }
      if (params['final_url']) {
        this.returnUrl = this.returnUrl + '&final_url=' + encodeURIComponent(params['final_url']);
      }
    }
  }

  private sanitizeReturnUrl(rawUrl: any): string {
    if (!rawUrl || typeof rawUrl !== 'string') {
      return '';
    }
    try {
      const parsed = new URL(rawUrl, window.location.origin);
      const allowedOrigins = [window.location.origin, environment.signup_domain];
      if (!/^https?:$/i.test(parsed.protocol) || allowedOrigins.indexOf(parsed.origin) === -1) {
        return '';
      }
      if (parsed.origin === window.location.origin) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
      return parsed.toString();
    } catch (e) {
      return '';
    }
  }

  checkAffCode() {
    if (this.affiliationCode.value === '' || this.affiliationCode.value === undefined || this.affiliationCode.value === null) {
      this.disabledSubmitButton = true;
    } else {
      this.disabledSubmitButton = false;
      this.isValidAffCode = true;
    }
  }

  cancelApplication(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (this.returnUrl) {
        if (this.returnUrl.indexOf('?') === -1) {
          this.redirectUrl(encodeURIComponent(this.returnUrl + '?fnStatus=ineligible'));
        } else {
          this.redirectUrl(encodeURIComponent(this.returnUrl + '&fnStatus=ineligible'));
        }
      } else {
        window.location.href = 'https://att.com';
      }
    }
  }

  isEncoded(url) {
    if (url !== '') {
      return url !== decodeURIComponent(url);
    }
  }

  redirectUrl(url) {
    if (this.isEncoded(url)) {
      window.location.href = decodeURIComponent(url);
    } else {
      window.location.href = url;
    }
  }

  getStart(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      window.location.href = environment.signup_domain + CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF;
    }
  }

  showAffiliationPage(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showLandingPage = false;
      this.showAffiliationCodePage = true;
      this.disabledSubmitButton = true;
    }
  }

  hideAffiliationPage(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showLandingPage = true;
      this.showAffiliationCodePage = false;
      this.affiliationCode.setValue('');
      this.isValidAffCode = true;
    }
  }

  submit(event) {
    if ((event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) &&
      (this.affiliationCode.value !== '' && this.affiliationCode.value !== null)) {
      sessionStorage.setItem('ngStorage-affCode', this.affiliationCode.value);
      this.showLoading = true;
      this.showLandingContainer = false;
      if (this.affiliationCode.value.length > 0) {
        const param = { retcode: this.affiliationCode.value };
        const url = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.GET_AFFILIATION_CODE, param)}`;
        this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {
          if (data && data.profile) {
            data.profile.forEach(val => {
              this.spaOrg(val);
            });
            this.OrgDetails.orgProfileInfo = data;
            this.OrgDetails.orgid = data.orgid;
            this.OrgDetails.orgName = data.orgName;
            this.OrgDetails.isSpaOrg = this.isSpaOrg;
            this.OrgDetails.affiliationCode = this.affiliationCode.value.replace(/ /g, '');
            sessionStorage.setItem('orgInfo', JSON.stringify(this.OrgDetails));
            localStorage.setItem('orgInfo', JSON.stringify(this.OrgDetails));
            this.redirection();
          }
        }, (_error1) => {
          this.showLoading = false;
          this.showLandingContainer = true;
          this.copyAffiliationCode = this.affiliationCode.value;
          this.isInvalidCode = true;
          // Display inline error message for incorrect Affiliation code
          this.isValidAffCode = false;
          // disable the continue button
          this.disabledSubmitButton = true;
        });
      } else {
        this.showLandingContainer = true;
        this.isValidAffCode = false;
        this.disabledSubmitButton = true;
      }
    }
  }

  spaOrg(val) {
    if (val.attribute_name === 'isSpaOrg' && val.attribute_value === 'TRUE') {
      this.isSpaOrg = true;
    }
  }

  redirection() {
    if (this.isSpaOrg) {
      window.location.href = environment.signup_domain.replace(/\/$/, '') + '/' + CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF;
    } else {
      window.location.href = environment.signup_domain.replace(/\/$/, '') + '/' + CfetPageNamesConstant.AFFILIATION_CODE_UTF;
    }
  }
}
